import React from "react";
import { useNavigate } from "react-router-dom";
import "./Profile.css";

const userProfile = {
  name: "Sagar L",
  email: "priya.sharma@awl.in",
  avatarInitial: "P",
  businessUnit: "AWL Agri",
  function: "Sales",
  officeLocation: "Mumbai HO",
};

export default function Profile() {
  const navigate = useNavigate();

  return (
    <div className="profile-page-container">
      <div className="profile-header">
        <button className="back-btn" onClick={() => navigate(-1)}>
          &lt;
        </button>
        <h2 className="profile-header-title">My Profile</h2>
      </div>

      <div className="profile-content">
        <div className="profile-hero">
          <div className="profile-avatar">{userProfile.avatarInitial}</div>
          <p className="profile-name">{userProfile.name}</p>
          <p className="profile-email">{userProfile.email}</p>
        </div>

        <div className="card profile-details-card">
          <div className="detail-item">
            <span className="detail-label">Business unit</span>
            <span className="detail-value">{userProfile.businessUnit}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Function</span>
            <span className="detail-value">{userProfile.function}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Office location</span>
            <span className="detail-value">{userProfile.officeLocation}</span>
          </div>
        </div>
      </div>
    </div>
  );
}